import { Map as ImmutableMap } from 'immutable';
import { createAction as reduxActionsCreator } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { TransactionRuleType } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';

export const DIALOG_TYPE = 'TRANSACTION_RULE_DIALOG';

export const TransactionRuleAction = reduxActionsCreator(
  rootUiActions.createDialog.toString(),
  ({
    id,
    transaction,
    rule,
    handleClose,
    originalIsReviewed,
  }: {
    id: string;
    rule?: TransactionRuleType;
    transaction?: TransactionRecord;
    handleClose: (rule: TransactionRuleType) => void;
    originalIsReviewed?: boolean | null;
  }) => {
    const props = {
      rule,
      transaction,
      handleClose,
      originalIsReviewed,
    };
    return rootUiTypes.mkRootUiData({
      id,
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap(props),
    });
  },
);
